import { useTranslation } from "react-i18next";
import tipsBg from "../../assets/tips_background.svg";
import reactions from "../../assets/reactions.webp";
import gamePad from "../../assets/game_pad.svg";
import starLight from "../../assets/starlight.svg";
import textSlate from "../../assets/text_slate.svg";
import mobileReactions from "../../assets/mobile_reaction.png";
import mobileTextDesign from "../../assets/mobile_text_deisgn.svg";

export function TipsSection() {
  const { t, i18n } = useTranslation();

  const cards = [
    { text: t("how_to_play.persuade"), rotation: "-rotate-2" },
    { text: t("how_to_play.every_round"), rotation: "rotate-1" },
    { text: t("how_to_play.expose"), rotation: "-rotate-1" },
  ];

  const isArabic = i18n.language === "ar";

  return (
    <section
      className="relative z-10 p-4 overflow-hidden bg-bottom bg-no-repeat bg-cover md:h-screen md:p-10"
      style={{ backgroundImage: `url(${tipsBg})` }}
      id="about"
    >
      {/* Content: two-column on desktop (image left, tips right), stack on mobile */}
      <div className="relative hidden md:flex flex-col lg:flex-row w-full max-w-[1400px] mx-auto">
        <img
          src={reactions}
          alt=""
          aria-hidden
          className="object-contain md:absolute -top-10 left-20 w-full max-w-[860px]"
        />
        <div
          className={`right-0 flex md:absolute ${isArabic ? "" : "flex-row-reverse"}`}
        >
          <img
            src={gamePad}
            alt=""
            aria-hidden
            className="w-20 h-20 mb-4 md:h-24 md:w-24 lg:h-32 lg:w-32"
          />
          <div className="relative flex flex-col gap-4 lg:mt-32">
            {cards.map((card, index) => (
              <div
                key={index}
                className={`relative ${card.rotation} transition-transform hover:rotate-0 hover:scale-105 duration-200`}
              >
                {/* Main card: image as background, text overlaid */}
                <div
                  className="relative px-10 py-8 bg-center bg-no-repeat bg-contain"
                  style={{ backgroundImage: `url(${textSlate})` }}
                >
                  <p
                    className={`${
                      isArabic
                        ? "text-3xl md:text-5xl sm:font-bold"
                        : "text-sm md:text-2xl"
                    }`}
                  >
                    {card.text}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
        <img src={starLight} alt="" className="absolute right-0 top-60" />
      </div>

      {/* Mobile view */}
      <div className="flex flex-col md:hidden" dir="ltr">
        <div className="flex mx-auto">
          <img
            src={mobileReactions}
            alt="Mobile Reactions"
            className="w-full max-w-[300px]"
          />
          <img src={gamePad} alt="" aria-hidden className="w-12 h-12" />
        </div>
        <div className="relative ml-20 -mt-20">
          {cards.map((card) => (
            <div
              key={card.text}
              style={{ backgroundImage: `url(${mobileTextDesign})` }}
              className="relative px-6 py-4 text-center bg-center bg-no-repeat bg-contain"
            >
              <p className={`font-semibold ${isArabic ? "" : "text-[12px]"}`}>
                {card.text}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
